@if (isAdvancedSearchApplied()) {
  <app-context-menu-item
    [withCheckOption]="true"
    [close]="true"
    title="All results"
  icon="sapphire-search"
    [active]="filterKey === 'search_results'"
    (execute)="selectFilter('search_results')"
  />
}

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Inbox"
  icon="sapphire-inbox"
  [active]="filterKey === 'inbox'"
  (execute)="selectFilter('inbox')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="VIP"
  icon="sapphire-vip"
  [active]="filterKey === 'vip'"
  (execute)="selectFilter('vip')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Flagged"
  icon="sapphire-flagged"
  [active]="filterKey === 'flagged'"
  (execute)="selectFilter('flagged')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Follow Up"
  icon="sapphire-follow-up"
  [active]="filterKey === 'followed'"
  (execute)="selectFilter('followed')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Snoozed"
  icon="sapphire-snooze"
  [active]="filterKey === 'snoozed'"
  (execute)="selectFilter('snoozed')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Drafts"
  icon="sapphire-draft"
  [active]="filterKey === 'draft'"
  (execute)="selectFilter('draft')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Scheduled"
  icon="sapphire-scheduled-send"
  [active]="filterKey === 'scheduled'"
  (execute)="selectFilter('scheduled')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Sent"
  icon="sapphire-sent"
  [active]="filterKey === 'sent'"
  (execute)="selectFilter('sent')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Other Mail"
  icon="sapphire-email"
  [active]="filterKey === 'other_mail'"
  (execute)="selectFilter('other_mail')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Bulk"
  icon="sapphire-bulk"
  [active]="filterKey === 'bulk'"
  (execute)="selectFilter('bulk')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Spam"
  icon="sapphire-spam"
  [active]="filterKey === 'spam'"
  (execute)="selectFilter('spam')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Archive"
  icon="sapphire-archive"
  [active]="filterKey === 'archived'"
  (execute)="selectFilter('archived')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Trash"
  icon="sapphire-trash"
  [active]="filterKey === 'deleted'"
  (execute)="selectFilter('deleted')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Folders"
  icon="sapphire-folders"
  [active]="filterKey === 'all_folders'"
  (execute)="selectFilter('all_folders')"
/>
